import { render, staticRenderFns } from "./ImagesControl.vue?vue&type=template&id=65c96b00"
import script from "./ImagesControl.vue?vue&type=script&lang=js"
export * from "./ImagesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c96b00')) {
      api.createRecord('65c96b00', component.options)
    } else {
      api.reload('65c96b00', component.options)
    }
    module.hot.accept("./ImagesControl.vue?vue&type=template&id=65c96b00", function () {
      api.rerender('65c96b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/controls/ImagesControl.vue"
export default component.exports